import { useHistory } from 'react-router-dom';
import AppLayout from '../../../../../component/appLayout';
import { getUrlParam, isEmpty } from '../../../../../helpers/common';
import { useCallback, useEffect } from 'react';
import { ROUTES } from '../../../../../routes/urls';
import { sentryAccountConnect } from '../../../../../services/settingServices';
import { rootStore } from '../../../../../mobx/rootStore';
import { observer } from 'mobx-react-lite';

function SentryCallback() {
  // mobx states
  const { currentWorkspace } = rootStore.workspaceStore || {};

  // Other variables
  const history = useHistory();
  const installationId = getUrlParam(history.location.search, 'installationId');
  const code = getUrlParam(history.location.search, 'code');

  const loadData = useCallback(async () => {
    if (!isEmpty(currentWorkspace?.id)) {
      // call service to add sentry connection
      if (installationId && code) {
        const payload = {
          installationId,
          code
        };
        const response = await sentryAccountConnect(payload);
        if (response) {
          history.push(ROUTES.INTEGRATIONS_SETTING);
        }
      } else {
        rootStore.alertNotificationStore.setErrorMessage('Invalid sentry redirect URL');
      }
    }
  }, [code, history, installationId, currentWorkspace?.id]);

  useEffect(() => {
    loadData();
  }, [loadData]);
  return <AppLayout>Loading ...</AppLayout>;
}

export default observer(SentryCallback);
